export default {
  user: null,
  sessionNotificationTime: 5
};
